/**
 * Safely coerce a selectedState value to string[].
 * Handles plain strings, arrays, and plain objects (PHP sparse arrays serialised
 * as JSON objects when array_filter leaves non-consecutive keys).
 */
export function toStringArray(value) {
    if (Array.isArray(value))
        return value.map(String);
    if (value != null && value !== "") {
        if (typeof value === "object") {
            return Object.values(value).map(String);
        }
        return [String(value)];
    }
    return [];
}
/**
 * Build a URL query string from selected filter state.
 * Arrays are serialized as repeated keys with `[]` suffix.
 */
export function buildQueryString(params) {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === "")
            return;
        if (Array.isArray(value)) {
            value.forEach((v) => v != null && v !== "" && search.append(`${key}[]`, String(v)));
        }
        else {
            search.set(key, String(value));
        }
    });
    const qs = search.toString();
    return qs ? `?${qs}` : "";
}
